import { AbstractAnswer } from "@kvix/shared";
import { Text } from "@kvix/ui";
import { Box, Container, makeStyles, Paper, Theme } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "../../../hooks/isMobile";
import { Comment } from "../../partials/Comment";

interface Props {
  comments: AbstractAnswer[];
}

const useStyles = makeStyles<Theme, Props>((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(6),
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
}));

export const ProgramComments: React.FC<Props> = (props) => {
  const { t, ready } = useTranslation("program");
  const classes = useStyles(props);
  const isMobile = useIsMobile();

  if (!(props.comments?.length > 0) || !ready) {
    return null;
  }

  return (
    <Paper className={classes.root}>
      <Container maxWidth="lg" style={{ marginBottom: "-24px" }}>
        <Box mb={8}>
          <Text variant="h3">{t("comments.title")}</Text>
        </Box>

        {props.comments.map((comment) => {
          if (!comment.user.name.last) {
            return;
          }
          return (
            <Box key={comment.id} pb="24px">
              <Comment comment={comment} asCompact={isMobile} />
            </Box>
          );
        })}
      </Container>
    </Paper>
  );
};
